const DefaultData = {
  APISERVERURL: "https://zotraiapi.azurewebsites.net/api/",
  APILOCALURL: "http://localhost:5126/api/",
  APIACTIVEURL: "https://zotraiapi.azurewebsites.net/api/",
  TENANTID: "zotrai",
  DEFAULTCOMPANYID: "D19EB72E-9995-4380-8E23-6A6E5316E035",//"D19EB72E-9995-4380-8E23-6A6E5316E035"
  DEFAULTBRANCHID: "bafb8c8c-706d-4c51-8dc3-de716b17de5a",
  DEFAULTCURRENCY: "INR",
  DEFAULTRKEY:"rzp_live_RM3FsGd3gROLea",
  APPLICATIONTYPE: "PRODUCTION",
  WEBSITE: "https://zotrai.com",
  DEFAULTCOMPANYEMAIL: "support@zotrai.com",
  DEFAULTCOMPANYPHONENUMBER: "9177656344",
  DEFAULTCOMPANYGST: "36ANVPM2246A1Z0",
  DEFAULTCOMPANYNAME: "SAAR DEVELOPERS CODE PVT LTD",
  DEFAULTBRANDNAME: "ZOTRAI",
  DEFAULTCOMPANYADDRESS: "HYDERABAD, TELANGANA",
  FACEBOOKURL: "https://www.facebook.com/zotrai",
  TWITTERURL: "https://x.com/zotrai",
  INSTGRAMURL: "https://www.instagram.com/zotrai",
  THEMECOLOR1: "#244892",
  THEMECOLOR2: "#1a1a1a",
  THEMECOLOR3: "#ffffff",
  THEMECOLOR4: "#000000",
  THEMECOLOR5: "#84804B",
  LANDINGPAGETITLE: "AI-Powered Travel CRM for the Next Generation of Agents",
  LANDINGPAGESUBTITLE: "Automate, analyze, and scale your travel business with intelligent technology.",
  B2BWEBSITE: "https://b2b.zotrai.com/",
  FOOTERCOPYRIGHTS: "2010 - 2025 SAAR DEVELOPERS CODE PVT LTD.",
  FOOTERSUBTITLE:
    "We make your dream more beautiful & enjoyable with lots of happiness.",
  COMPANYTYPE: "CLIENT",
  USERTYPE: "CLIENT",
  PLANTYPE: "TRIAL"
};

export default DefaultData;
